import { render } from "./BarButtonColor.vue?vue&type=template&id=2fe7124b&scoped=true"
import script from "./BarButtonColor.vue?vue&type=script&lang=js"
export * from "./BarButtonColor.vue?vue&type=script&lang=js"

import "./BarButtonColor.vue?vue&type=style&index=0&id=2fe7124b&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe7124b"]])

export default __exports__